module.exports = __webpack_public_path__ + "static/media/caterpillar.d40594dd.svg";